import { translate } from "app/filters/i18nFilter";
import type { FC } from "react";
import { proNavigator } from "single-spa/react-app/ProNavigator";
import { SubsectionHeader } from "@similarweb/ui-components";
import { SwTrack } from "app/services/SwTrack";

export const ConversionAnalysisNavBarHeader: FC<any> = () => {
    const handleClick = () => {
        proNavigator.go("conversion-homepage");
    };
    const onCreateNewClick = () => {
        SwTrack.all.trackEvent("Button", "click", `Side Bar/Add Group`);
        proNavigator.go("conversion-wizard");
    };
    const conversionHeaderId = translate("conversion.sidenav.title");
    return (
        <SubsectionHeader
            text={conversionHeaderId}
            id={conversionHeaderId}
            onClick={handleClick}
            onAddClick={onCreateNewClick}
        />
    );
};
